<ng-container *ngrxLet="loaderState$ as state">
  @if (state) {
    <div class="loader-container">
      <div class="loader">
        <div class="circle"></div>
      </div>
    </div>
  }
</ng-container>
